import toast, { Toaster } from "react-hot-toast";
import React, { useState, useEffect } from "react";
import { Breadcrumb, BreadcrumbItem, Row, Col } from "reactstrap";

//Componentes
import LoadingTransparent from "../../components/modales/loadingModalTransparent";
import IconCard from "../../components/cards/iconCard";
import CustomModal from "../../components/modales/customModal";
import BodyMail from "./components/BodyMail";
import BodyUserId from "./components/BodyUserId";
import BodyCreate from "./components/BodyCreate";
import BodyCrearFlujo from "./components/BodyCrearFlujo";
import BodyBuscarFlujo from "./components/BodyBuscarFlujo";
import BodyUpdate from "./components/BodyUpdate";
import BodyUpdatePass from "./components/BodyUpdatePass";
import BodyUserSignature from "./components/BodyUserSignature";
import BodyInformeAPEs from "./components/BodyInformeAPEs";
import BodyHabilitarCargaContrato from "./components/BodyHabilitarCargaContrato";

//Redux
import { connect } from "react-redux";

//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

//Info usuario en Reducer
const mapStateToProps = (state) => ({
  usuarioActivo: state,
});
let GestionUsuarios = (props) => {
  const [modal, setModal] = useState(false);
  const [modalTransaction, setModalTransaction] = useState(false);
  const [activeModal, setActiveModal] = useState(1);
  useEffect(() => {});

  const getBodyModal = () => {
    switch (activeModal) {
      case 1:
      default:
        return (
          <BodyMail
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggle={() => toggleModal()}
          />
        );
      case 2:
        return (
          <BodyUpdate
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggle={() => toggleModal()}
          />
        );
      case 3:
        return (
          <BodyCreate
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggleLoading={() => {
              toggleModalTransaction();
            }}
            toggle={() => toggleModal()}
          />
        );
      case 5:
        return (
          <BodyUpdatePass
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggle={() => toggleModal()}
          />
        );
      case 6:
        return (
          <BodyUserId
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggle={() => toggleModal()}
          />
        );
      case 7:
        return (
          <BodyUserSignature
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggleLoading={() => {
              toggleModalTransaction();
            }}
            toggle={() => toggleModal()}
          />
        );
      case 8:
        return (
          <BodyCrearFlujo
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggleLoading={() => {
              toggleModalTransaction();
            }}
            toggle={() => toggleModal()}
          />
        );
      case 9:
        return (
          <BodyBuscarFlujo
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggleLoading={() => {
              toggleModalTransaction();
            }}
            toggle={() => toggleModal()}
          />
        );
      case 10:
        return (
          <BodyInformeAPEs
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggleLoading={() => {
              toggleModalTransaction();
            }}
            toggle={() => toggleModal()}
          />
        );
      case 11:
        return (
          <BodyHabilitarCargaContrato
            toastSuccess={(e) => {
              toastSuccess(e);
            }}
            toastError={(e) => {
              toastError(e);
            }}
            toggleLoading={() => {
              toggleModalTransaction();
            }}
            toggle={() => toggleModal()}
          />
        );
    }
  };

  const getTitleModal = () => {
    switch (activeModal) {
      case 1:
      default:
        return "Busqueda por correo";
      case 2:
        return "Actualizar Correo";
      case 3:
        return "Crear usuario";
      case 4:
        return "Eliminar usuario";
      case 5:
        return "Actualizar Contraseña";
      case 6:
        return "Busqueda por Cédula";
      case 7:
        return "Cargar Cedula";
      case 8:
        return "Crear Flujo de Aprobación";
      case 9:
        return "Actualizar Flujo de Aprobación";
      case 10:
        return "Informe APEs";
      case 11:
        return "Estado Carga Contratos";
    }
  };

  const toggleModal = () => setModal(!modal);
  const toggleModalTransaction = () =>
    setModalTransaction(
      (prevStateModalTransaction) => !prevStateModalTransaction
    );

  const renderModal = () => {
    return (
      <CustomModal
        modal={modal}
        toggle={() => toggleModal()}
        title={getTitleModal()}
        nonFooter={true}
        size={"lg"}
      >
        {getBodyModal()}
      </CustomModal>
    );
  };
  return (
    <div>
      {renderModal()}
      {/* <ToastContainer autoClose={3000} closeOnClick position="bottom-left" /> */}
      <LoadingTransparent isOpen={modalTransaction} />
      <Breadcrumb>
        <BreadcrumbItem className="breadcum-display-content" active>
          Gestión de Usuarios
        </BreadcrumbItem>
      </Breadcrumb>
      <div className="user-management-page">
        <Row>
          <Col lg="3" md="6" xs="12">
            <IconCard
              icon={"AiOutlineUserAdd"}
              subText={"Crear Usuario"}
              onClick={() => {
                setActiveModal(3);
                toggleModal();
              }}
            />
          </Col>
          <Col lg="3" md="6" xs="12">
            <IconCard
              icon={"AiOutlineSearch"}
              subText={"Buscar Usuario"}
              onClick={() => {
                setActiveModal(6);
                toggleModal();
              }}
            />
          </Col>
          <Col lg="3" md="6" xs="12">
            <IconCard
              icon={"AiOutlineLock"}
              subText={"Actualizar Contraseña"}
              onClick={() => {
                setActiveModal(5);
                toggleModal();
              }}
            />
          </Col>
          <Col lg="3" md="6" xs="12">
            <IconCard
              icon={"AiOutlinePicture"}
              subText={"Cargar Firma"}
              onClick={() => {
                setActiveModal(7);
                toggleModal();
              }}
            />
          </Col>
          <Col lg="3" md="6" xs="12">
            <IconCard
              icon={"AiOutlineDeploymentUnit"}
              subText={"Crear Flujo de Aprobación"}
              onClick={() => {
                setActiveModal(8);
                toggleModal();
              }}
            />
          </Col>
          <Col lg="3" md="6" xs="12">
            <IconCard
              icon={"AiOutlineFileSearch"}
              subText={"Buscar Flujo de Aprobación"}
              onClick={() => {
                setActiveModal(9);
                toggleModal();
              }}
            />
          </Col>
          <Col lg="3" md="6" xs="12">
            <IconCard
              icon={"AiOutlineFileSearch"}
              subText={"Informe APEs"}
              onClick={() => {
                setActiveModal(10);
                toggleModal();
              }}
            />
          </Col>
          <Col lg="3" md="6" xs="12">
            <IconCard
              icon={"AiOutlineFileSearch"}
              subText={"Carga Contratos"}
              onClick={() => {
                setActiveModal(11);
                toggleModal();
              }}
            />
          </Col>
        </Row>
      </div>
      <Toaster />
    </div>
  );
};

export default connect(mapStateToProps)(GestionUsuarios);
